<template>
  <v-dialog scrollable fullscreen persistent v-model="model" max-width="600px">
    <v-card height="500px">
      <v-card-title class="ma-0 pa-0">
        <v-row class="ma-0 pa-0 mt-3" justify="start">
          <v-col cols="3" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" justify="start" align="center">
              <v-btn
                v-if="!loading"
                @click="model = false"
                text
                class="text-none primary--text"
                >{{ labels.CLOSE }}
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="6" class="ma-0 pa-0">
            <v-row
              justify="center"
              align="center"
              class="vetalfa-row ma-0 pa-0 px-4"
            >
              <p class="text-center vetalfa-dialog-title pt-1 pa-0 ma-0">
                {{ modes[mode].title }}
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text
        v-if="mode == 0"
        id="references-card-text"
        class="ma-0 pa-0 py-4"
      >
        <vetalfa-section-title
          v-if="references.length"
          prop="Referências adicionadas:"
        >
          <v-row class="ma-0 pa-0">
            <v-data-table
              :headers="headers"
              :items="references"
              :items-per-page="1000"
              hide-default-footer
              sort-by="calories"
              class="elevation-1"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small @click="deleteReference(item)">
                  {{ mdiTrashCanOutline }}
                </v-icon>
              </template>
            </v-data-table>
          </v-row>
        </vetalfa-section-title>
        <vetalfa-section-title prop="Referências adicionadas:" v-else>
          <v-col class="ma-0 pa-0 pt-2 mt-5" cols="12">
            <v-row class="ma-0 pa-0" justify="center">
              <v-img
                position="center"
                height="100px"
                class="ma-0 pa-0"
                :src="noDrugsImage"
                :lazy-src="noDrugsImage"
                max-width="300"
                contain
              ></v-img>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 px-5" cols="12">
            <p class="vetalfa-card-title-disabled text-center ma-0 pa-0 mt-5">
              {{ labels.NO_CONTENT }}
            </p>
            <p class="vetalfa-card-text-disabled ma-0 pa-0 mt-1">
              Clique em "Adicionar referência" para criar novos itens
            </p>
          </v-col>
        </vetalfa-section-title>
      </v-card-text>
      <v-card-text
        v-if="mode == 1"
        id="references-card-text"
        class="ma-0 pa-0 py-4"
      >
        <vetalfa-section-title
          prop="Que tipo de referência você deseja incluir?"
          class="ma-0 pa-0 mt-5"
        >
          <chip-group
            :clearTrigger="clearTrigger"
            v-on:selectChip="selectReferenceType"
            :items="[
              'Referência PubMed',
              'Referência Vet Alfa',
              'Referência Padrão/Externa',
            ]"
            :defaultValue="0"
            class="px-2"
          ></chip-group>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Qual o nome do artigo?"
          class="ma-0 pa-0 mt-5"
          v-if="referenceTypeIndex == 2"
        >
          <v-textarea
            auto-grow
            rows="1"
            type="text"
            hide-details
            class="ma-0 pa-0 px-2 mt-3"
            light
            dense
            color="primary"
            :value="name"
            v-model="name"
            outlined
            placeholder="Nome"
          ></v-textarea>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Qual o ano do artigo?"
          class="ma-0 pa-0 mt-5"
          v-if="referenceTypeIndex == 2"
        >
          <v-textarea
            auto-grow
            rows="1"
            type="text"
            hide-details
            class="ma-0 pa-0 px-2 mt-3"
            light
            dense
            color="primary"
            :value="year"
            v-model="year"
            outlined
            placeholder="Ano"
          ></v-textarea>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Qual o nome da revista/fonte?"
          class="ma-0 pa-0 mt-5"
          v-if="referenceTypeIndex == 2"
        >
          <v-textarea
            auto-grow
            rows="1"
            type="text"
            hide-details
            class="ma-0 pa-0 px-2 mt-3"
            light
            dense
            color="primary"
            :value="magazine"
            v-model="magazine"
            outlined
            placeholder="Revista/Fonte"
          ></v-textarea>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Insira o nível de evidência:"
          class="ma-0 pa-0 mt-5"
          v-if="referenceTypeIndex == 0 || referenceTypeIndex == 2"
        >
          <chip-group
            :clearTrigger="clearTrigger"
            v-on:selectChip="selectLevelType"
            :items="evidences.items"
            :defaultValue="0"
            class="px-2"
          ></chip-group>
          <v-select
            v-if="levelScope"
            :items="levelScope.levels"
            v-model="level"
            hide-details
            filled
            class="ma-0 pa-0 px-2 mt-2"
            dense
            label="Nível de evidência"
            outlined
          ></v-select>
          <v-combobox
            v-if="levelScope"
            :items="evidences.addenda"
            v-model="addendum"
            class="ma-0 pa-0 px-2 mt-5"
            dense
            label="Adendos (Opcional)"
            outlined
          ></v-combobox>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Texto no formato PubMed"
          class="ma-0 pa-0 mt-5"
          v-if="referenceTypeIndex == 0"
        >
          <v-textarea
            auto-grow
            rows="1"
            type="text"
            hide-details
            class="ma-0 pa-0 px-2 mt-3"
            light
            dense
            color="primary"
            :value="pubmed"
            v-model="pubmed"
            outlined
            placeholder="Referência PubMed"
          ></v-textarea>
        </vetalfa-section-title>
        <vetalfa-section-title
          prop="Qual o link do item?"
          class="ma-0 pa-0 mt-5"
          v-if="referenceTypeIndex == 1 || referenceTypeIndex == 2"
        >
          <v-textarea
            auto-grow
            rows="1"
            type="text"
            class="px-2 mt-5"
            light
            dense
            color="primary"
            :value="link"
            v-model="link"
            outlined
            placeholder="Link"
          ></v-textarea>
        </vetalfa-section-title>
      </v-card-text>
      <v-card-text
        v-if="mode == 2"
        id="references-card-text"
        class="ma-0 pa-0 py-4"
      >
        <vetalfa-section-title
          prop="Selecione quais referências você quer associar:"
        >
          <v-card v-if="references.length" class="ma-2 pa-0">
            <v-list class="ma-0 pa-0">
              <v-list-item-group v-model="referencesSelection" multiple>
                <template v-for="(item, i) in references">
                  <v-divider v-if="i > 0" :key="`divider-${i}`"></v-divider>
                  <v-list-item
                    :key="`item-${i}`"
                    :value="item.id"
                    active-class="primary--text text--accent-4"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="`${i + 1}. ${item.name}`"
                        ></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="primary accent-4"
                        ></v-checkbox>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>
          <v-row v-else class="ma-0 pa-0 mt-3">
            <v-col class="ma-0 pa-0 pt-2 mt-5" cols="12">
              <v-row class="ma-0 pa-0" justify="center">
                <v-img
                  position="center"
                  height="100px"
                  class="ma-0 pa-0"
                  :src="noDrugsImage"
                  :lazy-src="noDrugsImage"
                  max-width="300"
                  contain
                ></v-img>
              </v-row>
            </v-col>
            <v-col class="ma-0 pa-0 px-5" cols="12">
              <p class="vetalfa-card-title-disabled text-center ma-0 pa-0 mt-5">
                {{ labels.NO_CONTENT }}
              </p>
              <p class="vetalfa-card-text-disabled ma-0 pa-0 mt-1">
                Clique em "Adicionar referência" para criar novos itens
              </p>
            </v-col>
          </v-row>
        </vetalfa-section-title>
      </v-card-text>
      <v-card-actions class="ma-0 px-2 py-4">
        <v-row class="ma-0 pa-0 white" justify="end">
          <v-col class="ma-0 pa-0 mr-2" :cols="4">
            <v-btn
              v-if="modes[mode].backButton && !loading"
              class="text-none primary--text"
              light
              @click="mode = previousMode"
              block
              outlined
            >
              {{ modes[mode].backText }}
            </v-btn>
          </v-col>
          <v-col class="ma-0 pa-0" :cols="4">
            <v-btn
              :elevation="disabledStep ? 0 : 5"
              v-bind:class="
                disabledStep ? 'vetalfa-disabled-btn' : 'vetalfa-primary-btn'
              "
              :loading="loading"
              class="text-none"
              light
              @click="performAction()"
              block
            >
              {{ modes[mode].action }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import labels from "@/constants/labels.js";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { mdiTrashCanOutline } from "@mdi/js";
import imagesConstants from "@/constants/images.js";
import ChipGroup from "@/components/ChipGroup.vue";
export default {
  name: "ReferencesManagement",
  components: {
    "chip-group": ChipGroup,
  },
  computed: {
    ...mapGetters("general", ["loading"]),
    disabledStep() {
      if (this.mode == 1) {
        if (this.referenceTypeIndex == 0) {
          return !this.pubmed || !this.level;
        }
        if (this.referenceTypeIndex == 2) {
          return !this.name || !this.year || !this.magazine || !this.level;
        }
        return !this.link;
      }
      return false;
    },
    referencesNames() {
      let names = [];
      this.references.forEach((r) => {
        names.push(r.name);
      });
      return names;
    },
  },
  watch: {
    model(val) {
      if (!val) {
        this.previousMode = 0;
        this.$emit("toggleReferencesModel", val);
      } else {
        this.mode = 0;
        if (this.sectionReferences) {
          this.mode = 2;
          this.referencesSelection = [];
          for (let reference of this.references) {
            this.sectionReferences.forEach((sectionReference) => {
              if (sectionReference.id === reference.id) {
                this.referencesSelection.push(reference.id);
              }
            });
          }
        }
      }
    },
    referencesSelection(val) {
      let arr = [];
      if (val) {
        val.forEach((id) => {
          arr.push(
            this.references.filter((reference) => {
              return reference.id == id;
            })[0]
          );
        });
      }
      this.$emit("referencesSelection", arr);
    },
  },
  methods: {
    ...mapMutations("general", ["setConfirmModel"]),
    ...mapActions("management", ["getInternalReference"]),
    performAction() {
      this.modes[this.mode].method(this);
    },
    selectLevelType(val) {
      this.levelScope = this.evidences.scopes[val];
      this.level = "";
    },
    selectReferenceType(val) {
      this.referenceTypeIndex = val;
      this.referenceType = { 0: 0, 1: 1, 2: 0 }[val];
    },
    editReference(reference) {
      this.name = reference.name;
      this.year = reference.year;
      this.magazine = reference.magazine;
      this.level = reference.level;
      this.link = reference.link;
      this.referenceIdentifier = reference.id;
      this.mode = 1;
    },
    deleteReference(reference) {
      this.referenceToDelete = reference;
      this.setConfirmModel({
        text: "Deseja deletar a referência selecionada? Esta referência também será removida de itens associados no texto.",
        confirmText: "Deletar referência",
        closeText: "Cancelar",
        active: true,
        callback: this.deleteCallback,
      });
    },
    deleteCallback() {
      this.$emit("deleteReference", this.referenceToDelete.id);
    },
  },
  props: {
    model: {
      type: Boolean,
      default: false,
      required: true,
    },
    references: {
      type: Array,
      required: true,
    },
    sectionReferences: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      pubmed: "",
      referenceTypeIndex: 0,
      referenceType: 0,
      referenceIdentifier: null,
      referencesSelection: [],
      labels,
      name: "",
      year: "",
      magazine: "",
      addendum: "",
      level: "",
      link: "",
      ticksLabels: [1, 2, 3, 4, 5],
      mode: 2,
      modes,
      mdiTrashCanOutline,
      referenceToDelete: null,
      noDrugsImage: imagesConstants.NO_RESULTS,
      previousMode: 0,
      evidences,
      levelScope: null,
      clearTrigger: null,
      headers: [
        { text: "Título", value: "name", sortable: false },
        { text: "Fonte", value: "magazine", sortable: false },
        { text: "Ano", value: "year", sortable: false },
        { text: "Categoria", value: "category", sortable: false },
        { text: "Detalhes", value: "description", sortable: false },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  mounted() {
    if (process.env.NODE_ENV !== "development") {
      window.onbeforeunload = function () {
        return "Are you sure";
      };
    }
  },
};

const modes = {
  0: {
    title: "Gestão de Referências",
    action: "Adicionar referência",
    method: (ctx) => {
      ctx.mode = 1;
    },
    backButton: false,
    backText: "",
  },
  1: {
    title: "Adição/Edição de Referências",
    action: "Salvar referência",
    method: async (ctx) => {
      if (ctx.disabledStep) {
        return;
      }

      if (ctx.referenceType == 0) {
        let lines = ctx.pubmed.split("\n");
        lines.forEach((line, index) => {
          if (line.startsWith("PMID")) {
            const pmid = line.slice(4).trim().slice(1).trim();
            ctx.link = `https://pubmed.ncbi.nlm.nih.gov/${pmid}/`;
          } else if (line.startsWith("TI")) {
            ctx.name = line.slice(2).trim().slice(1).trim();
            let aux = index;
            while (aux) {
              if (
                lines[aux + 1] &&
                !lines[aux + 1].slice(2).trim().startsWith("-")
              ) {
                ctx.name += ` ${lines[aux + 1].trim()}`;
                aux++;
              } else {
                aux = false;
              }
            }
          } else if (line.startsWith("JT")) {
            ctx.magazine = line.slice(2).trim().slice(1).trim();
            if (lines[index + 1] && !lines[index + 1].includes("-")) {
              ctx.magazine += ` ${lines[index + 1].trim()}`;
            }
          } else if (line.startsWith("DP")) {
            ctx.year = line.slice(2).trim().slice(1).trim().split(" ")[0];
          }
        });
      }

      const regExp = /\(([^)]+)\)/;
      let matches = regExp.exec(ctx.level);
      let reference = {
        type: ctx.referenceType,
        id: ctx.referenceIdentifier || ctx._getTimestamp(),
        name: ctx.name,
        year: ctx.year,
        magazine: ctx.magazine,
        level: ctx.level,
        link: ctx.link,
        addendum: ctx.addendum,
        levelNumber: matches ? new Number(matches[1]) : 0,
      };
      if (ctx.referenceType == 1) {
        reference = await ctx.getInternalReference(ctx.link);
      }
      ctx.$emit("addReference", reference);
      ctx.name = "";
      ctx.year = "";
      ctx.magazine = "";
      ctx.level = "";
      ctx.link = "";
      ctx.addendum = "";
      ctx.pubmed = "";
      ctx.mode = ctx.previousMode;
      ctx.referenceIdentifier = null;
      ctx.referenceType = 0;
      setTimeout(function () {
        const element = document.getElementById("references-card-text");
        element.scrollTop = element.scrollHeight;
      }, 1000);
    },
    backButton: true,
    backText: "Voltar",
  },
  2: {
    title: "Associação de Referências",
    action: "Adicionar referência",
    method: (ctx) => {
      ctx.previousMode = 2;
      ctx.mode = 1;
    },
    backButton: false,
    backText: "",
  },
};

const evidences = {
  items: [
    "Benefícios Tratamento",
    "Malefícios Tratamento",
    "Prognóstico",
    "Diagnóstico",
    "Screening",
    "Não se Aplica",
  ],
  scopes: [
    {
      name: "Benefícios Tratamento",
      levels: [
        "(1) Review Sistemático | Estudo Randomizado Controlado",
        "(2) Estudo Randomizado Controlado | Cego",
        "(3) Estudo Randomizado Controlado | Não Cego",
        "(3) Estudo de Coorte Prospectivo",
        "(3) Estudo Controlado não Randomizado",
        "(4) Estudo Retrospectivo",
        "(4) Estudo com Controle Histórico",
        "(4) Estudo Clínico de Braço-Único",
        "(4) Relato de Caso",
        "(4) Séries de Casos",
        "(4) Caso Controle",
        "(5) Estudo in-vitro",
        "(5) Estudo Baseado em Raciocínio Mecanístico",
        "(5) Artigo de Opinião",
        "(5) Estudo ex-vivo sem PIO (Patient-Important Outcomes)",
        "(5) Estudo em outras espécies",
      ],
    },
    {
      name: "Malefícios Tratamento",
      levels: [
        "(1) Review Sistemático | Estudo Randomizado Controlado",
        "(1) Review Sistemático | Nested Case Control",
        "(2) Estudo Randomizado Controlado | Cego",
        "(3) Estudo de Coorte Prospectivo",
        "(3) Estudo Randomizado Controlado | Não Cego",
        "(3) Estudo Controlado não Randomizado",
        "(4) Estudo Retrospectivo",
        "(4) Estudo com Controle Histórico",
        "(4) Estudo Clínico de Braço-Único",
        "(4) Relato de Caso",
        "(4) Séries de Casos",
        "(4) Caso Controle",
        "(5) Estudo in-vitro",
        "(5) Estudo Baseado em Raciocínio Mecanístico",
        "(5) Artigo de Opinião",
        "(5) Estudo ex-vivo sem PIO (Patient Important Outcomes",
      ],
    },
    {
      name: "Prognóstico",
      levels: [
        "(1) Review Sistemático | Inception Cohort Prospectivo",
        "(2) Inception Cohort Prospectivo",
        "(3) Estudo de Coorte Prospectivo",
        "(3) Estudo Randomizado Controlado",
        "(4) Relato de Caso",
        "(4) Séries de Casos",
        "(4) Caso Controle",
        "(4) Estudo Retrospectivo",
        "(4) Estudo com Controle Histórico",
        "(4) Estudo Clínico de Braço-Único",
        "(5) Estudo Baseado em Raciocínio Mecanístico",
        "(5) Artigo de Opinião",
      ],
    },
    {
      name: "Diagnóstico",
      levels: [
        "(1) Review Sistemático | Corte Transversal – Cego e Comparado com Gold Standard (Single-gate design)",
        "(2) Corte Transversal – Cego e Comparado com Gold Standard (Single-gate design) ",
        "(3) Corte Transversal – Não Cego",
        "(3) Corte Transversal – Não Comparado com Gold Standard",
        "(3) Corte Transversal – Não Cego e Não Comparado com Gold Standard",
        "(3) Estudo com Pacientes não Consecutivos",
        "(4) Caso Controle",
        "(4) Valor de Referência não Independente",
        "(5) Estudo Baseado em Raciocínio Mecanístico",
        "(5) Artigo de Opinião",
      ],
    },
    {
      name: "Screening",
      levels: [
        "(1) Review Sistemático | Estudo Randomizado Controlado",
        "(2) Estudo Randomizado Controlado | Cego",
        "(3) Estudo de Coorte Prospectivo",
        "(3) Estudo Randomizado Controlado | Não Cego",
        "(3) Estudo Controlado não Randomizado",
        "(4) Estudo Retrospectivo",
        "(4) Estudo com Controle Histórico",
        "(4) Estudo Clínico de Braço-Único",
        "(4) Relato de Caso",
        "(4) Séries de Casos",
        "(4) Caso Controle",
        "(5) Estudo in-vitro",
        "(5) Estudo Baseado em Raciocínio Mecanístico",
        "(5) Artigo de Opinião",
        "(5) Estudo ex-vivo sem PIO (Patient Important Outcomes)",
      ],
    },
    {
      name: "Não se Aplica",
      levels: [
        "-",
        "Review não sistemático",
        "Livro",
        "Consenso",
        "Guideline",
        "Estudo Farmacológico Estrito",
        "Estudo de Incidência/Prevalência",
      ],
    },
  ],
  addenda: [
    "(+) Duplo cego",
    "(+) Cego",
    "(-) Critérios subjetivos",
    "(-) Surrogate",
    "(-) Sem avaliação de PIO (Patient-Important Outcomes)",
    "(-) Baixo tempo de follow-up",
    "(-) N-baixo",
  ],
};
</script>